import { useAuth } from "@/composables/useAuth";
import { Ability } from "@/interfaces/ability";
import { SidebarAction } from "@/interfaces/sidebarAction";
import { User } from "@/modules/users/interfaces/user";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useAuthStore = defineStore("auth", () => {
  const { user: authUser, refetch } = useAuth();

  const user = ref<User>();
  const sidebarActions = ref<SidebarAction[]>();
  const abilities = ref<Ability[]>([]);

  return {
    user,
    sidebarActions,
    abilities,

    // Getters
    userIsInternal() {
      return user.value?.internal;
    },
    isAuthenticated: () => computed(() => authUser.value !== undefined),

    // Actions
    refetch,

    setUser(authUser: User) {
      user.value = authUser;
    },

    setSidebarActions(actions: SidebarAction[]) {
      sidebarActions.value = actions;
    },
    setAbilities(abilitiesUser: Ability[]) {
      abilities.value = abilitiesUser;
    },

    resetState() {
      user.value = undefined;
      sidebarActions.value = undefined;
    },
  };
});
